import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const projectMembershipApi = generateNomenApi(`/project/project-membership`);

export const projectMembershipOptions = generateNomenOptions('project-membership', projectMembershipApi);
